import { FC, memo, ReactNode, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import Logo from "../../assets/img/Logo.svg";
import WelcomeContent from "../../components/WelcomeContent";
import { useAppSelector as useSelector } from "../../store";

/**
 * Authentication Page Props Interface
 * @interface AuthenticationPageProps
 */

interface AuthenticationPageProps {
  /** Auth page content */
  children?: ReactNode;
}

const SignupPage: FC<AuthenticationPageProps> = ({ children }) => {
  const location = useLocation();
  const scrollRef = useRef<HTMLDivElement>(null);

  const [signUpDone, setSignUpDone] = useState<boolean>(false);
  const [screenSize, setScreenSize] = useState<boolean>(false);

  const showSignUpDetails = useSelector(
    (state) => state.auth.showSignUpDetails
  );

  // to check the page is sent invitation or not for decide showing or not showing the logo
  useEffect(() => {
    if (
      ((location.pathname === "/signup" || location.pathname === "/Signup") &&
        showSignUpDetails === true) ||
      location.pathname === "/sent-invitation" ||
      location.pathname === "/email-verification" || 
      location.pathname === "/account-activation" || 
      location.pathname === "/email-verified"
    ) {
      setSignUpDone(true);
    } else {
      setSignUpDone(false);
    }
  }, [location, showSignUpDetails]);

  useEffect(() => {
    if (
      location.pathname === "/privacy-policy" ||
      location.pathname === "/terms-of-use"
    ) {
      setScreenSize(true);
    } else {
      setScreenSize(false);
    }
  }, [location]);

  const isErrorPage = location.state?.is404 === true;

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [location]);

  return (
    <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center">
      <WelcomeContent screenSize={screenSize} />
      <div ref={scrollRef}
        className={`w-100 desktop-overflow ${!screenSize ? "max-w-600px" : ""}`}
      >
        <div className="position-relative mobile-top bg-white p-40px d-flex align-items-center justify-content-center">
          <div
            className={`d-flex flex-column gap-15 ${
              !screenSize ? "w-400px" : ""
            }`}
          >
            {!signUpDone && !isErrorPage && (
              <>
                <div className="auth-logo">
                  <img
                    src={Logo}
                    alt="Logo"
                    width={190}
                    className="img-fluid"
                  />
                </div>
                <div className="h-10px w-100"></div>
              </>
            )}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(SignupPage);
